<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <div class="mb-3">
      <div class="row">
        <div class="col-11">
          <h4>Avisos</h4>
        </div>
        <div class="col-1">
          <span class="material-symbols-outlined" style="font-size:32px;color:blue; cursor: pointer;" @click="showModalHelp = true">help</span>
        </div>
      </div>
    </div>
    <Modal v-model:modelValue="showModalHelp">
      <AyudaAviso />
    </Modal>
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col">Titulo</th>
          <th scope="col">Texto</th>
          <th scope="col">EstadoAviso</th>
          <th scope="col">FechaReg</th>
          <th scope="col">FechaEnvio</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="aviso in datosPaginados" :key="aviso.idAviso">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(aviso.idAviso)" title="Editar">edit_square</i></td>
          <td>{{aviso.titulo}}</td>
          <td>{{aviso.texto}}</td>
          <td>{{aviso.estadoAviso}}</td>
          <td>{{getFormattedDate(aviso.fechaReg, 'DD/MM/YYYY')}}</td>
          <td>{{getFormattedDate(aviso.fechaEnvio, 'DD/MM/YYYY')}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteAviso(aviso.idAviso)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example" v-if="!popupAyuda">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idAviso" class="form-label">Id. Aviso</label>
                </div>
                <div class="col-4">
                  <input type="text" class="form-control" id="idAviso" name="idAviso" v-model="datoAviso.idAviso" disabled>
                </div>
                <div class="col-2">
                  <label for="fechaReg" class="form-label">Fecha Reg.</label>
                </div>
                <div class="col-4">
                  <input type="text" class="form-control" id="fechaReg" name="fechaReg" v-model="datoAviso.fechaReg" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="titulo" class="form-label">Titulo</label>
                </div>
                <div class="col-10">
                  <input type="text" class="form-control" id="titulo" name="titulo" v-model="datoAviso.titulo" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="texto" class="form-label">Texto</label>
                </div>
                <div class="col-10">
                  <textarea class="form-control" id="texto" name="texto" v-model="datoAviso.texto" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="estadoAviso" class="form-label">Estado</label>
                </div>
                <div class="col-4">
                  <input type="text" class="form-control" id="estadoAviso" name="estadoAviso" v-model="datoAviso.estadoAviso" style='text-transform:uppercase' required>
                </div>
                <div class="col-2">
                  <label for="fechaEnvio" class="form-label">Fecha Envío</label>
                </div>
                <div class="col-4">
                  <input type="date" class="form-control" id="fechaEnvio" name="fechaEnvio" v-model="datoAviso.fechaEnvio" required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarAviso" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditAviso" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditAvisoEstado" v-if="btnEditar">Listo</button>
      </div>
    </div>
  </div>
</div>
    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import AyudaAviso from '@/views/ayuda/AyudaAviso.vue'
import { validarForm } from '@/modules/validacionesForms.js'
import dateFormat from '@/modules/dateFormat.js';

import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer, AyudaAviso
  },
  data () {
    return {
      avisos : [],
      datoAviso : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      popupAyuda: false,
      showModalHelp: false,
      estiloImagen: {
        width: "200px",
        height: "200px"
      }
    }
  },
  mounted () {
    this.getDataPaginaTodos(this.paginaActual)
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    totalPaginas(){
      return Math.ceil(this.avisos.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwavisos/nombre/'+this.nombreBusqueda).then(response=>{
          this.avisos=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.avisos.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwavisos/idempresa/'+window.sessionStorage.getItem("idEmpresa")).then(response=>{
      this.avisos=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.avisos.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarForm(){
      const requiredFields = [
        'texto'
      ];
      const requiredFieldsText = [
        'texto'
      ];
      return validarForm(this.datoAviso, requiredFields, requiredFieldsText);
    },
    async guardarAviso(){
      if(this.validarForm() === 1){
        try {
          this.datoAviso.idEmpresa = window.sessionStorage.getItem("idEmpresa");
          await api.post('/avisos', this.datoAviso)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "Aviso creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditAviso(){
      if(this.validarForm() === 1){
        try {
          await api.post('/avisos', this.datoAviso)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "Aviso creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    async guardarEditAvisoEstado(){
      if(this.validarForm() === 1){
          this.datoAviso.estadoAviso = "PENDIENTE";
        try {
          await api.post('/avisos', this.datoAviso)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "Aviso creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoAviso={}
      this.titulo   = 'Registrar Aviso'
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirModalEditar(idAviso){
      this.modalWindow = true
      if(idAviso != null){    
           api.get('/vwavisos/'+idAviso).then(resp=>{
          this.datoAviso = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Aviso'
      this.btnCrear = false
      this.btnEditar= true
    },
    async deleteAviso (idAviso) {
      try{
        await api.delete('/avisos/'+idAviso)
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
    openHelp() {
      this.popupAyuda = true;
      this.$refs.helpPopup.open();
    },
    handlePopupClosed() {
      this.popupAyuda = false;
    }
  },
}
</script>
<style src="@/assets/css/listaFiltrada.css" scoped></style>
